import { useEffect, type ReactNode } from 'react';
import Lottie from 'lottie-react';

import { Button, Text } from '~/atomic';
import loadingAnimation from '~/assets/lottie/payment-loading.json';
import successAnimation from '~/assets/lottie/payment-success.json';

export function ProcessingView({
  subtitle,
  onRefresh,
}: {
  subtitle?: string;
  onRefresh?: () => void;
}) {
  return (
    <div className="flex h-[68vh] flex-col items-center justify-center gap-medium text-center">
      <div className="h-[168px] w-[168px]">
        <Lottie animationData={loadingAnimation} loop autoplay />
      </div>
      <Text as="h2" className="text-headingH1 color-complement-01">
        Confirmando pagamento
      </Text>
      <Text className="max-w-[320px] text-bodyMD color-intense-06">
        {subtitle ??
          'Estamos processando sua cobrança com segurança. Isso leva apenas alguns segundos.'}
      </Text>
      {onRefresh ? (
        <Button text="Atualizar status" variant="secondary" onClick={onRefresh} />
      ) : null}
    </div>
  );
}

export function SuccessView({
  title = 'Plano ativado!',
  message,
  planName,
  cta = 'Começar a usar',
  onDone,
}: {
  title?: string;
  message?: ReactNode;
  planName?: string;
  cta?: string;
  onDone: () => void;
}) {
  useEffect(() => {
    const t = window.setTimeout(onDone, 4500);
    return () => window.clearTimeout(t);
  }, [onDone]);

  return (
    <div className="flex h-[68vh] flex-col items-center justify-center gap-medium text-center animate-fade_in">
      <div className="h-[188px] w-[188px]">
        <Lottie animationData={successAnimation} loop={false} autoplay />
      </div>
      <Text as="h1" className="text-display1 color-primary-01">
        {title}
      </Text>
      <Text className="max-w-[320px] text-bodyMD color-intense-06">
        {message ?? (
          <>
            Seu pagamento foi confirmado e o acesso completo do{' '}
            <strong>{planName}</strong> já está liberado. Bom trabalho!
          </>
        )}
      </Text>
      <Button text={cta} rightIcon="icon-chevron-right" onClick={onDone} />
    </div>
  );
}
